import React, { Component } from "react";

import { getPrivacyPolicy$ } from "../../../redux/actions/cms";
// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import {
  EditorState,
  // ContentState,
  // convertFromHTML,
  // convertToRaw
} from "draft-js";
// import draftToHtml from "draftjs-to-html";

import Button from "components/CustomButtons/Button";

import { connect } from "react-redux";

import axios from "../../../config/axios";

import toastr from "toastr";
import loaderIcon from "assets/img/loader.gif";

/* Editor Component */
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["image"],
    //['link', 'image', 'video'],
    //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    ["blockquote", "code-block"],
    //[{ 'direction': 'rtl' }],                         // text direction
    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    ["clean"] // remove formatting button
  ]
};
class ManagePrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      readOnly: true,
      loading: false
    };
  }
  componentDidMount() {
    this.props.handleGetPrivacyPolicy();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.privacyPolicy !== prevProps.privacyPolicy &&
      this.props.privacyPolicy.data &&
      this.props.privacyPolicy.data.data
    ) {
      const editorState = this.props.privacyPolicy.data.data;
      // const editorState = EditorState.createWithContent(
      //   ContentState.createFromBlockArray(
      //     convertFromHTML(this.props.privacyPolicy.data.data)
      //   )
      // );
      this.setState({ editorState });
    }
  }

  handleEditPrivacyPolicy = () => {
    this.setState({ readOnly: false });
  };

  handleSubmitPrivacyPolicy = () => {
    this.setState({ loading: true });
    // const data = {
    //   data: encodeURIComponent(
    //     draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
    //   )
    // };
    const data = {
      data: this.state.editorState
    };
    axios
      .put(`privacypolicy/${this.props.privacyPolicy.data.id}`, data)
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          toastr.success("Privacy Policy updated Successfully!");
          this.props.handleGetPrivacyPolicy();
          this.setState({ readOnly: true, loading: false });
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        toastr.error(err.response.data.message + ". Please try again!");
      });
  };

  render() {
    const { editorState, readOnly, loading } = this.state;
    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} alt="loader"/>
          </div>
        ) : (
          <React.Fragment>
            <ReactQuill
              onChange={(newValue, delta, source) => {
                //console.log("onChange newValue:::: ", newValue, delta)
                this.setState({ editorState: newValue });
              }}
              onBlur={(range, source, quill) => {
                //console.log("onBlur quill.getHTML():::: ", quill.getHTML(), range, source,quill, quill.getLength(), quill.getText())
                console.log(quill.getHTML());
              }}
              modules={modules}
              theme="snow"
              value={editorState}
              readOnly={readOnly}
            />
            {/* <Editor
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"
              editorState={editorState}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={editorState =>
                this.setState({ editorState })
              }
              readOnly={readOnly}
            /> */}
            <p>*Please upload the images only in 692px x 400px resolution</p>
            {this.state.readOnly ? (
              <Button
                variant="contained"
                color="iseas"
                onClick={this.handleEditPrivacyPolicy}
              >
                Edit
              </Button>
            ) : (
              <Button
                variant="contained"
                color="iseas"
                onClick={this.handleSubmitPrivacyPolicy}
              >
                Submit
              </Button>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    privacyPolicy: state.cms.privacy_policy
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetPrivacyPolicy: () => dispatch(getPrivacyPolicy$.trigger())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagePrivacyPolicy);



// WEBPACK FOOTER //
// ./src/views/ISEAS/ContentBuilder/ManagePrivacyPolicy.js